import React from "react";

import { Text, TextLink } from "@origin-digital/ods-core";

import { CONTENT } from "../../consts";

export const Disclaimer: React.FC = () => {
  const {
    disclaimer: { link },
  } = CONTENT;

  return (
    <Text data-id="movers-widget-wp-disclaimer" variant="body-small">
      For energy pricing, see{" "}
      <TextLink href={link} target="_blank">
        Basic Plan Information / Energy Fact Sheets
      </TextLink>
    </Text>
  );
};
